import React from 'react';
import {useTranslation} from 'react-i18next';
import {TEticketOrder} from '../../../../redux/eTicket/eTicket.type';
import * as css from './TicketDetailsHeader.css';

interface TicketDetailsHeaderProps {
    buyerName: string;
    order?: TEticketOrder;
}

function TicketDetailsHeader({buyerName, order}: TicketDetailsHeaderProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.header data-cy="ticket-details-header">
            {buyerName && <css.buyerName>{buyerName}</css.buyerName>}
            {order?.oid != null && (
                <css.transactionNo>
                    {t('transactionNumber', {oid: order.oid})}
                </css.transactionNo>
            )}
            
        </css.header>
    );
}

export default TicketDetailsHeader;
